var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuoteCtrl = function () {
    function QuoteCtrl(EndorsementService, StateUtils) {
        _classCallCheck(this, QuoteCtrl);

        this.EndorsementService = EndorsementService;
        this.StateUtils = StateUtils;
    }

    _createClass(QuoteCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var calculatePercentage = function calculatePercentage(premium, changeInCost) {
                return Math.abs(Math.floor(changeInCost * 100 / premium));
            };
            var removeSign = function removeSign(field) {
                var copy = Object.assign({}, field);
                copy.amount = Math.abs(field.amount);
                return copy;
            };

            this.finish = this.finish.bind(this);
            this.increase = this.changeInCost.amount > 0;
            this.decrease = this.changeInCost.amount < 0;
            this.noChange = this.changeInCost.amount === 0;
            this.changeInCostNoSign = removeSign(this.changeInCost);
            this.percentage = calculatePercentage(this.previousPremium.amount, this.changeInCost.amount);
            this.showPaymentStepButton = this.alwaysShowPaymentStep || this.increase;
        }
    }, {
        key: 'finish',
        value: function finish(nextFn) {
            var model = this.StateUtils.activeDataForState(true).model;
            var paymentDetails = {
                paymentMethod: 'redistribute'
            };
            this.EndorsementService.bind(model.jobID.value, paymentDetails).then(function () {
                return nextFn(model);
            });
        }
    }]);

    return QuoteCtrl;
}();

QuoteCtrl.$inject = ['endorsement.EndorsementService', 'StateUtils'];

export default QuoteCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/quote/quoteCtrl.js
// module id = 1012
// module chunks = 0